import { logger } from 'monitor';
import posthog from 'posthog-js';

const POSTHOG_TOKEN_PROD = 'phc_Exn4SQXc4GKrxK19pkbhFyJ3xQIeHvQCsGmAL35y5nr';
const POSTHOG_TOKEN_TEST = 'phc_q9dsjcijZ81e4OnnWzXgEJYnlIDWFDBwrJFz8y4llZY';

export const initPosthog = () => {
  logger.debug('Posthog is being initialized');

  if (import.meta.env.VITE_DEBUG_ANALYTICS !== 'true' && window.location.hostname === 'localhost') {
    logger.debug(
      'Posthog is disabled in development mode, skipping initialization. Set VITE_DEBUG_ANALYTICS=true to enable.'
    );
    return;
  }
  const token = getPosthogApiKey();

  if (token) {
    posthog.init(token, getPosthogOptions());
    logger.debug('Posthog has been initialized');
  }
};
export const initAnalytics = () => {
  if (!posthog.__loaded) initPosthog();
};

export const getPosthogApiKey = () => {
  const token = import.meta.env.VITE_ENV === 'PROD' ? POSTHOG_TOKEN_PROD : POSTHOG_TOKEN_TEST;

  if (!token.length) {
    logger.error('Posthog is disabled because the token is empty', {
      POSTHOG_TOKEN_PROD,
      POSTHOG_TOKEN_TEST,
      env: import.meta.env.VITE_ENV,
      token,
    });
    return undefined;
  }
  return token;
};

export const getPosthogOptions = () => {
  return {
    api_host: 'https://eu.i.posthog.com',
    enable_heatmaps: true,
    person_profiles: 'always' as const,
  };
};
